import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Auth from "./Pages/Auth";
import Home from "./Pages/Home";
import Profile from "./Pages/Profile";
import ProtectedRoute from "./components/ProtectedRoute";
import Donors from "./Pages/Donors";
import Navbar from "./components/Navbar";
import TourismDetails from "./Pages/Tourismdetails";
import Tourism from "./Pages/Tourism";
import TopNavbar from "./components/TopNavBar";
import About from "./Pages/About";
import Help from "./Pages/Help";
import Hospitals from "./Pages/Hospitals";
import Schools from "./Pages/Schools";
import Emergency from "./Pages/Emergency";
import LabourList from "./Pages/LabourList";
import Panchayaths from "./Pages/Panchayath";
import NotFound from "./Pages/NotFound";
import ScrollToTop from "./components/SrollToTop";
import Drivers from "./Pages/Drivers";
import Charity from "./Pages/Charity";
import Places from "./Pages/Places";
import Trains from "./Pages/Trains";
import Terms from "./Pages/Terms";
import Privacy from "./Pages/Privacy";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      {/* 🔥 GLOBAL TOASTER */}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 2000,
          style: {
            background: "#111",
            color: "#fff",
            borderRadius: "10px",
            fontSize: "14px",
          },
        }}
      />
 <TopNavbar/>
 <ScrollToTop />
      <Routes>
       
        <Route path="/" element={<Home />} />

        <Route path="/auth" element={<Auth />} />
        <Route path="/donors" element={<Donors/>} />
        <Route path="/tourism/:id" element={<TourismDetails />} />
         <Route path="/tourism" element={<Tourism />} />
         <Route path="/about" element={<About/>} />
         <Route path="/help" element={<Help/>} />
          <Route path="/hospitals" element={<Hospitals/>} />
          <Route path="/schools" element={<Schools/>} /> 
          <Route path="/emergency" element={<Emergency/>} /> 
          <Route path="/labours" element={<LabourList />} />
        <Route path="/panchayath" element={<Panchayaths />} />
        <Route path="/drivers" element={<Drivers/>} />
         <Route path="/charity" element={<Charity/>} />
          <Route path="/places" element={<Places/>} />
          <Route path="/trains" element={<Trains/>} />
           <Route path="/terms" element={<Terms/>} />
          <Route path="/privacy" element={<Privacy/>} />
        <Route path="*" element={<NotFound/>} />
        {/* 🔐 PROTECTED PROFILE */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Footer/>
      <Navbar/>
    </>
  );
}

export default App;